/**
 * AppearanceSection - Visual customization settings
 * Contains metric color thresholds and other display preferences
 */

import { MetricThresholdsSettings } from '@/components/settings/MetricThresholdsSettings'

export function AppearanceSection() {
  return (
    <div className="space-y-6">
      <MetricThresholdsSettings />

      {/* Future appearance settings can be added here */}
      {/* Example: Theme selection, date format, number format, etc. */}
    </div>
  )
}
